import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import { Layout } from 'src/modules/app/components/Layout';
import { LayoutWrapper } from 'src/modules/app/components/Router/LayoutWrapper';
import { NavBar } from 'src/modules/designStudio/components/NavBar';
import {
  Robots as MetaRobots,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useTranslate } from 'src/shared/hooks';
import { useReactNativeWebView } from 'src/shared/hooks/useReactNativeWebView';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const NotFound = () => {
  const t = useTranslate(TranslationNamespace.NOT_FOUND);
  const [isWebView] = useReactNativeWebView();

  return (
    <>
      <MetaRobots mode="none" />
      <MetaTitle title={t('pageNotFound')} />
      <LayoutWrapper wrapper={isWebView ? undefined : Layout}>
        <Box
          alignItems="center"
          height="100%"
          justifyContent="center"
          testId="design-studio-not-found"
          width="100%"
        >
          <NavBar
            isOnline
            menu={null}
            onSavedDesignsMenuOpen={() => null}
            setMenu={() => null}
            showShare={false}
            showUndoRedo={false}
          />
          <Heading size={700}>404</Heading>
        </Box>
      </LayoutWrapper>
    </>
  );
};

export { NotFound };
